import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';

import { ICostCurrencies, ICostOptions } from './settings-general-cost-options.model';

@Injectable({
    providedIn: 'root',
})
export class SettingsGeneralCostOptionsService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private loggerService: LoggerService,
        private translation: NDDTranslationService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-general`;
    }

    public getCostOptions(): Observable<ICostOptions> {
        return this.http.get<ICostOptions>(`${ this.apiUrl }/costs`);
    }

    public getCurrencies(): Observable<ICostCurrencies> {
        return this.http.get<ICostCurrencies>(`${ this.apiUrl }/costs-currency-list`);
    }

    public updateCostOptions(command: ICostOptions): Observable<boolean> {
        return this.http.post<boolean>(`${ this.apiUrl }/costs`, command)
            .pipe(tap(() => this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')])));
    }
}
